import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const AboutSection = () => {
  const milestones = [{
    year: '2022',
    achievement: 'Company Founded'
  }, {
    year: '2024',
    achievement: 'Launched First Residential Project'
  }, {
    year: '2024',
    achievement: 'Expanded to Commercial Development'
  }];
  const values = [{
    title: 'Quality',
    description: 'We never compromise on the quality of our developments'
  }, {
    title: 'Innovation',
    description: 'Embracing new technologies and design philosophies'
  }, {
    title: 'Trust',
    description: 'Building lasting relationships with our clients and partners'
  }, {
    title: 'Sustainability',
    description: 'Creating eco-friendly spaces for future generations'
  }];
  return <section id="about" className="py-20 bg-white" data-id="element-118" data-mp="1955vk8om3ijf">
      <div className="container mx-auto px-4 lg:px-8" data-id="element-119" data-mp="1e7db188nhgqi">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-120" data-mp="1dmnsteiqlzi5">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-121" data-mp="1dnqjblc5dzxj">
            About Swastik Infra Developer
          </h2>
          <div className="w-20 h-1 bg-blue-800 mx-auto mb-6" data-id="element-122" data-mp="14lh7ms5580ik"></div>
          <p className="max-w-3xl mx-auto text-gray-600 text-lg" data-id="element-123" data-mp="14ntnmzrcc0sz">
            Building excellence through innovation, quality, and customer
            satisfaction since 2022.
          </p>
        </div>
        {/* Vision & Mission */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20" data-id="element-124" data-mp="1sbjumtu7agab">
          <div className="bg-gray-50 p-8 rounded-lg shadow-sm" data-id="element-125" data-mp="1sdnyxcw0hhb4">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-126" data-mp="1njaa5tbuu8ff">
              Our Vision
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-127" data-mp="1ikz0bilk7xx7">
              To be the most trusted name in real estate development, creating
              landmark properties that enhance the quality of life and
              contribute to sustainable urban development.
            </p>
            <div className="space-y-3" data-id="element-128" data-mp="9doqckhi1r1y">
              {values.slice(0, 2).map((value, index) => <div key={index} className="flex items-start" data-id="element-129" data-mp="dd5w7f0u8q7n" data-mpi={index}>
                  <CheckCircleIcon className="h-5 w-5 text-blue-800 mt-0.5 mr-2 flex-shrink-0" data-id="element-130" data-mp="3vs83yeynh27d" />
                  <div data-id="element-131" data-mp="4lx7yx8hyrmw">
                    <h4 className="font-medium text-gray-900" data-id="element-132" data-mp="4l3znrtw3u2n">{value.title}</h4>
                    <p className="text-sm text-gray-600" data-id="element-133" data-mp="3luai1y49jhhx">{value.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg shadow-sm" data-id="element-134" data-mp="3qr0xcj88u92a">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-135" data-mp="3cunqe41c5q22">
              Our Mission
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-136" data-mp="3hsyzudnpxyjr">
              To create exceptional living and working spaces through innovative
              design, superior craftsmanship, and unwavering commitment to
              customer satisfaction.
            </p>
            <div className="space-y-3" data-id="element-137" data-mp="1q4r5ueu1ttyt">
              {values.slice(2).map((value, index) => <div key={index} className="flex items-start" data-id="element-138" data-mp="1l6642az5f289" data-mpi={index}>
                  <CheckCircleIcon className="h-5 w-5 text-blue-800 mt-0.5 mr-2 flex-shrink-0" data-id="element-139" data-mp="1l3tgniamfznt" />
                  <div data-id="element-140" data-mp="1yzfco9f9vjpq">
                    <h4 className="font-medium text-gray-900" data-id="element-141" data-mp="1u6m9hpzgcjfr">{value.title}</h4>
                    <p className="text-sm text-gray-600" data-id="element-142" data-mp="1u4hxekrege4e">{value.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        {/* Milestones */}
        <div data-id="element-143" data-mp="2hw6s27rp1eoi">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-10" data-id="element-144" data-mp="2hvx0ifr02zgp">
            Our Journey
          </h3>
          <div className="relative" data-id="element-145" data-mp="2dubtvc527hey">
            {/* Timeline Line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-100" data-id="element-146" data-mp="ni5rnighwjmb"></div>
            {/* Timeline Items */}
            <div className="space-y-12 md:space-y-0" data-id="element-147" data-mp="ji54n9fbz03n">
              {milestones.map((milestone, index) => <div key={index} className="relative md:flex items-center justify-between" data-id="element-148" data-mp="kxg9o55cqox0" data-mpi={index}>
                  {/* Left side (even) or right side (odd) content */}
                  <div className={`md:w-5/12 mb-8 md:mb-0 ${index % 2 === 0 ? 'md:text-right md:pr-12' : 'md:order-last md:text-left md:pl-12'}`} data-id="element-149" data-mp="twl6n719ma72">
                    <h4 className="text-xl font-bold text-gray-900" data-id="element-150" data-mp="255aal9wp93n">
                      {milestone.year}
                    </h4>
                    <p className="text-gray-600" data-id="element-151" data-mp="b86eggf7oq4o">{milestone.achievement}</p>
                  </div>
                  {/* Timeline dot */}
                  <div className="absolute left-0 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 rounded-full bg-blue-800 border-4 border-white" data-id="element-152" data-mp="fzeoneod8fiw"></div>
                  {/* Right side (even) or left side (odd) - empty space for alignment */}
                  <div className={`md:w-5/12 ${index % 2 === 0 ? 'md:order-last' : ''}`} data-id="element-153" data-mp="3c474fnj7nijp"></div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default AboutSection;